import { call, put, takeLatest, fork, all, delay } from "redux-saga/effects";
import * as Types from "../constants/Types";
import * as AuthService from "./../services/authService";
import * as Func from "../helpers/functions";
// import { getMomentDate } from "../utils/commonUtils";
import history from "../helpers/history";
import * as Auth from "../actions/authAction";
import i18n from "../constants/initLng";
import $ from "jquery";
import { get } from "lodash";
import {
  CONFIG_LOCAL_STORAGE,
  PATHS,
  REFRESH_TOKEN_DELAY_TIMEOUT,
} from "../constants/Define";
// import CONFIG from '../constants/Config';
import { LocalStorage } from "../utils";
import { message } from "antd";
// import moment from 'moment';

function* redirectTo(location) {
  yield history.push(location);
}

let countgetProfile = 0;

function* loginSaga() {
  yield takeLatest(
    Types.LOGIN_ACTION,
    Func.sagaWrapper(function* () {
      if (countgetProfile <= 3) {
        // Add a small delay
        yield delay(3000); // Import delay from redux-saga/effects

        const authState = yield call(AuthService.getAuthToken);

        if (!authState) {
          yield put({ type: Types.LOGIN_AUTHENTICATING, authenticating: true });
          yield call(AuthService.loginAd);
        } else {
          const accessToken = authState.accessToken;
          // const data = yield call(AuthService.login, body.username, body.password, body.googleCaptchaResponse);
          const data = yield call(AuthService.login, { accessToken });
          if (data.accessToken) {
            yield put({ type: Types.LOGIN_SUCCESS });
            LocalStorage.set(
              CONFIG_LOCAL_STORAGE.ACCESS_TOKEN,
              data.accessToken,
            );
            LocalStorage.set(
              CONFIG_LOCAL_STORAGE.REFRESH_TOKEN,
              data.refreshToken,
            );
            LocalStorage.set(CONFIG_LOCAL_STORAGE.EXPIRES, data.expires);
            yield put({ type: Types.CHECK_USER_ACTION });
            yield call(redirectTo, PATHS.ROOT);
          }
          yield put({
            type: Types.LOGIN_AUTHENTICATING,
            authenticating: false,
          });
        }
      }
    }, errorHandleAuth(Types.LOGIN_FAILED)),
  );
}

function* logoutSaga() {
  yield takeLatest(
    Types.LOGOUT_ACTION,
    Func.sagaWrapper(function* (action) {
      yield call(AuthService.logout);
      yield put({ type: Types.LOGIN_AUTHENTICATING });

      // Clear LocalStorage items
      LocalStorage.remove(CONFIG_LOCAL_STORAGE.AUTHENTICATING);
      LocalStorage.remove(CONFIG_LOCAL_STORAGE.ACCESS_TOKEN);
      LocalStorage.remove(CONFIG_LOCAL_STORAGE.REFRESH_TOKEN);
      LocalStorage.remove(CONFIG_LOCAL_STORAGE.EXPIRES);
      LocalStorage.remove(CONFIG_LOCAL_STORAGE.PROFILE);

      // Clear all cookies
      document.cookie.split(";").forEach(function (c) {
        document.cookie = c
          .replace(/^ +/, "")
          .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });

      // Logout from AD
      yield call(AuthService.logoutAd);
    }, errorHandleAuth(Types.LOGIN_FAILED)),
  );
}

function* setAuthenticating() {
  yield takeLatest(
    Types.LOGIN_AUTHENTICATING,
    Func.sagaWrapper(function (action) {
      LocalStorage.set(
        CONFIG_LOCAL_STORAGE.AUTHENTICATING,
        action.authenticating,
      );
    }, errorHandleProfile(Types.LOGIN_FAILED)),
  );
}

function* checkUserSaga() {
  yield takeLatest(
    Types.CHECK_USER_ACTION,
    Func.sagaWrapper(function* (action) {
      countgetProfile++;
      const data = yield call(AuthService.getUserProfile);
      LocalStorage.set(CONFIG_LOCAL_STORAGE.PROFILE, data);
      yield put(Auth.checkUserSuccess(data));
    }, errorHandleProfile(Types.LOGIN_FAILED)),
  );
}

function* refreshTokenFunc(action, shouldGetProfile = true) {
  const refreshToken =
    action.refreshToken || LocalStorage.get(CONFIG_LOCAL_STORAGE.REFRESH_TOKEN);
  const expires = LocalStorage.get(CONFIG_LOCAL_STORAGE.EXPIRES);
  const shouldRefresh =
    parseInt(new Date().getTime()) >=
    parseInt(new Date(expires).getTime()) - REFRESH_TOKEN_DELAY_TIMEOUT;
  let intervalLoaded = false;

  function* refreshTokenInterval() {
    if (shouldGetProfile) {
      yield put({ type: Types.CHECK_USER_ACTION });
    }
    if (!intervalLoaded) {
      const expireDate = LocalStorage.get(CONFIG_LOCAL_STORAGE.EXPIRES);
      const delayTimeout =
        parseInt(new Date(expireDate).getTime()) -
        parseInt(new Date().getTime()) -
        REFRESH_TOKEN_DELAY_TIMEOUT;
      yield delay(delayTimeout);
      yield call(
        refreshTokenFunc,
        { refreshToken: LocalStorage.get(CONFIG_LOCAL_STORAGE.REFRESH_TOKEN) },
        false,
      );
      intervalLoaded = true;
    }
  }

  if (shouldRefresh && refreshToken) {
    const data = yield call(AuthService.refreshToken, refreshToken);
    if (data.accessToken) {
      yield put({ type: Types.REFRESH_TOKEN_SUCCESS });
      LocalStorage.set(CONFIG_LOCAL_STORAGE.ACCESS_TOKEN, data.accessToken);
      LocalStorage.set(CONFIG_LOCAL_STORAGE.REFRESH_TOKEN, data.refreshToken);
      LocalStorage.set(CONFIG_LOCAL_STORAGE.EXPIRES, data.expires);
      yield refreshTokenInterval();
    }
  } else {
    yield refreshTokenInterval();
  }
}

function* refreshTokenSaga() {
  yield takeLatest(
    Types.REFRESH_TOKEN_ACTION,
    Func.sagaWrapper(refreshTokenFunc, errorHandleRefresh(Types.LOGIN_FAILED)),
  );
}

function errorHandleAuth(errorActionType) {
  return function* (e) {
    if (e.status === 401) {
      const code = get(e, "errors[0].code");
      const mess = code && i18n.t(`validation.statusCode.code.${code}`);
      message.error(mess || i18n.t("validation.usernameOrPasswordNotMatch"));
    } else if (e.errors) {
      let code =
        e.code ||
        e.errors.title ||
        get(e, "errors[0].code") ||
        "UNDEFINED_ERROR";
      const message = get(e, "errors[0].message");
      if (message === "Invalid Captcha") code = "INVALID_CAPTCHA";
      message.error(i18n.t(`validation.statusCode.code.${code}`), true);
    } else if (e.status) {
      message.error(i18n.t(`validation.statusCode.code.${e.status}`), true);
    } else {
      message.error(`${i18n.t(`validation.connectFail`)}: ${e}`, true);
    }
    yield put({ type: errorActionType });
  };
}

function errorHandleProfile(errorActionType) {
  return function* (e) {
    if (e.status === 401) {
      yield put({ type: Types.LOGOUT_ACTION });
      LocalStorage.remove(CONFIG_LOCAL_STORAGE.ACCESS_TOKEN);
      LocalStorage.remove(CONFIG_LOCAL_STORAGE.REFRESH_TOKEN);
      LocalStorage.remove(CONFIG_LOCAL_STORAGE.EXPIRES);
      LocalStorage.remove(CONFIG_LOCAL_STORAGE.PROFILE);
      history.go(PATHS.LOGIN.path);
    } else {
      $("div.alert").slideDown(300);
      message.error(i18n.t("validation.connectfail"), true);
      yield put({ type: errorActionType });
    }
  };
}

function errorHandleRefresh(errorActionType) {
  return function* (e) {
    if (e.errors) {
      LocalStorage.remove(CONFIG_LOCAL_STORAGE.ACCESS_TOKEN);
      LocalStorage.remove(CONFIG_LOCAL_STORAGE.REFRESH_TOKEN);
      LocalStorage.remove(CONFIG_LOCAL_STORAGE.EXPIRES);
      history.go(PATHS.LOGIN.path);
    } else {
      Func.alertMessage(
        i18n.t("notifi.title"),
        i18n.t("validation.usernameOrPasswordNotMatch"),
        true,
      );
      yield put({ type: errorActionType });
    }
  };
}

export function* authSaga() {
  yield all([
    fork(loginSaga),
    fork(logoutSaga),
    fork(checkUserSaga),
    fork(refreshTokenSaga),
    fork(setAuthenticating),
  ]);
}
